import { useContext } from 'react';
import { ReactRouterContext } from '../components';
import { Params } from '../types';

function useParams<T extends Params>(): Readonly<[T] extends [string] ? T : Partial<T>> {
    const { params } = useContext(ReactRouterContext);

    return {
        ...((params ?? {}) as T),
        // Inject store code to params as it's in use in dashboard-ui
        storeCode: params?.store,
    };
}

export default useParams;
